import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader } from '..';
// import { ActionHeader } from '../index';
import en from '../../../../lang/en-us';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { OtpField, ResendOtp, useTimer } from '../../../../lib/OtpField';
import {
    sendEmailOTP,
    verifyChangeEmailOTP,
    updateEmail,
} from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { OTP_ACTIONS } from '../../../../utils/constants';
import { nextScreen } from '../ChangeMobile/flow';
import { RowInfoType } from './change-email-list';
import { SUCCESS } from './flow';
const { dashboard } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function ChangeEmailOtp(props: any) {
    const {
        enteredEmail = null,
        emailRelationship = null,
        foliosToUpdate = [],
        images = [],
    } = props.location.state || {};

    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);

    useEffect(() => {
        const { otp, reqId, otpRef, enteredEmail } = props.location.state || {};

        if (!enteredEmail || (!foliosToUpdate.length && !!props.email)) {
            props.history.push('/');
            return;
        }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const { pan, pekrn, mobile } = props;
            const goTo = nextScreen(props.match.path, 'email');
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                enteredEmail,
                emailRelationship,
                pan,
                pekrn,
                mobile,
                action: props?.location?.state?.action,
            };

            await props.verifyChangeEmailOTP(payload);
            if (goTo === SUCCESS) {
                const data = foliosToUpdate.map((ele: RowInfoType) => {
                    return {
                        amc: ele.amc,
                        folio: ele.id,
                        newEmail: enteredEmail,
                        emailRelationship: emailRelationship,
                    };
                });
                let res = await props.updateEmail({
                    reqId,
                    mobile,
                    pan: props.pan,
                    pekrn: props.pekrn,
                    source: 'R',
                    data,
                    ...(images.length ? { images } : {}),
                });
                props.history.replace('change-email-success', {
                    data: foliosToUpdate,
                    email: enteredEmail,
                    isOffline: !!images.length,
                    ...(res || {}).body,
                });
                return;
            }
            props.history.replace(goTo, { enteredEmail, reqId, emailRelationship });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const onResend = async () => {
        const { pan, pekrn, mobile } = props;
        try {
            let payload = {
                email: enteredEmail,
                pan,
                pekrn,
                mobile,
                action: props?.location?.state?.action,
            };
            let res = await props.sendEmailOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.changeEmail.changeEmailHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-otp-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.OtpScreen.subHeading}
                            <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                        </h3>
                        <p>
                            {dashboard.OtpScreen.otpEmailSubject}{' '}
                            <span style={{ fontFamily: 'Montserrat-Bold' }}>"{enteredEmail}"</span>
                        </p>
                        <OtpField
                            value={otpInput}
                            updateValue={(otp: string[]) => {
                                setCount(count + 1);
                                setOtp(otp);
                            }}
                            maskedInfo={`Please enter the 6-digit OTP sent to your registered email Id ${enteredEmail}`}
                            showModal={showModal}
                            _handleProceed={() => setShowModal(false)}
                        />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButtonWithLoader
                            disabled={otpInput.join('').length !== 6}
                            loading={loading}
                            label={dashboard.OtpScreen.buttonText}
                            labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                            onClick={handleSubmit}
                        />
                        <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    verifyChangeEmailOTP,
    sendEmailOTP,
    updateEmail,
})(ChangeEmailOtp);
